import { logEvent } from "firebase/analytics";
import { analytics } from "./firebase";

export const logUiEvent = (name, params = {}) => {
  if (!analytics) return;
  logEvent(analytics, name, params);
};
